import './text-media.scss';

class TextMedia {
    constructor(element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-textmedia',
            triggerValue: 'trigger'
        };

        // Merge settings
        this.settings = Object.assign({}, defaults, options);

        // DOM Elements
        this.$root = element;
        this.$playButton = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.triggerValue}"]`);
    }

    initialize() {
        if (this.$playButton) {
            import('../../utilities/js/youtube-player').then(({ YoutubePlayer }) => {
                this.initYoutubePlayer(YoutubePlayer);
            });
        }
    }

    initYoutubePlayer(YoutubePlayer) {
        const videoPlayer = new YoutubePlayer(this.$playButton, {
            eventScroller: window.eventScroller,
            autoplay: true,
            width: 1600,
            height: 900,
            onCall: () => {
                this.toggleState(true);
            },
            onEnd: () => {
                if (videoPlayer.player.video.isMuted() === false || videoPlayer.mute === 0) {
                    videoPlayer.destroy();
                    this.toggleState(false);
                }
            }
        });
    }

    toggleState(active) {
        if (active) {
            this.$playButton.setAttribute('hidden', '');
        } else {
            this.$playButton.removeAttribute('hidden');
        }
    }
}

export { TextMedia };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-textmedia="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new TextMedia($root);
            $rootAPI.initialize();
        });
    }
});
